//#region Modal
export const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    bgcolor: "#FFFFFF",
    boxShadow: "0px 0px 8px 0px #CCCCCC"
};
export const modalStyleLarge = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",    
    bgcolor: "#FFFFFF",
    boxShadow: "0px 0px 8px 0px #CCCCCC"
};
export const modalStyleUltraLarge = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "900px",
    bgcolor: "#FFFFFF",
    boxShadow: "0px 0px 8px 0px #CCCCCC"
}
export const modalStyleXLarge = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "1100px",
    height: "60vh",
    bgcolor: "#FFFFFF",
    boxShadow: "0px 0px 8px 0px #CCCCCC"
}
export const modalStyleUltraUltraLarge = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '1850px',
    height: '80vh',
    maxHeight: '80vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
}
export const modalStylePdfViewer = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '92%',
    maxWidth: '1400px',
    height: '95vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
}
//#endregion

//#region Chip
export const chipGreen = {
    "&.MuiChip-root.MuiChip-root": {
        background: "#91d250",
        ":hover": {
            background: "#91d250"
        }
    },
    "&.MuiChip-root.MuiChip-root .MuiChip-label": {
        color: "#000000"
    },
};
export const chipYellow = {
    "&.MuiChip-root.MuiChip-root": {
        background: "#F1DA21",
        ":hover": {
            background: "#F1DA21"
        }
    },
    "&.MuiChip-root.MuiChip-root .MuiChip-label": {
        color: "#000000"
    },
};
export const chipOrange = {
    "&.MuiChip-root.MuiChip-root": {
        background: "#febf00",
        ":hover": {
            background: "#febf00"
        }
    },
    "&.MuiChip-root.MuiChip-root .MuiChip-label": {
        color: "#000000"
    },
};
export const chipRed = {
    "&.MuiChip-root.MuiChip-root": {
        background: "#ff5c5f",
        ":hover": {
            background: "#ff5c5f"
        }
    },
    "&.MuiChip-root.MuiChip-root .MuiChip-label": {
        color: "#000000"
    },
};
export const chipGray = {
    "&.MuiChip-root.MuiChip-root": {
        background: "#B0B0B0",
        ":hover": {
            background: "#B0B0B0"
        }
    },
    "&.MuiChip-root.MuiChip-root .MuiChip-label": {
        color: "#000000"
    },
};
export const chipblue = {
    "&.MuiChip-root.MuiChip-root": {
        background: "#2196f3",
        ":hover": {
            background: "#2196f3"
        }
    },
    "&.MuiChip-root.MuiChip-root .MuiChip-label": {
        color: "#000000"
    },
};
//#endregion

//#region Div
export const divOrange = {
    background: "#FDB927",
    color: "#FFFFFF",
    borderRadius: 4,
    padding: "4px",
    fontSize: "12px",
    width: "70px",
    textAlign: "center"
};
export const divGreen = {
    background: "#09822A",
    color: "#FFFFFF",
    borderRadius: 4,
    padding: "4px",
    fontSize: "12px",
    width: "70px",
    textAlign: "center"
};
export const divRed = {
    background: "#D82829",
    color: "#FFFFFF",
    borderRadius: 4,
    padding: "4px",
    fontSize: "12px",
    width: "70px",
    textAlign: "center"
};
export const divYellow = {
    background: "#D3850A",
    color: "#FFFFFF",
    borderRadius: 4,
    padding: "4px",
    fontSize: "12px",
    width: "70px",
    textAlign: "center"
};
//#endregion